<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import { stockjournalService } from "../../../services/financeservice/stockjournal.service";
import { stockjournalentryService } from "../../../services/financeservice/stockjournalentry.service";


/* eslint-disable no-console */
export default {
  page: {
    title: "Project Summary",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Project Summary",
      items: [
        {
          text: "project",
          href: "/",
        },
        {
          text: "Detail", 
          active: true,
        },
      ],
      stockJournalData: null,
      stockJournalEntryData: []
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData(this.$route.params.id);
    this.loadingByJournal(this.$route.params.id);
    
  },
  methods: {
    
     
    loadingData: function(id) {
      
      this.fetchingStats = false;
      stockjournalService.getOne(id)
        .then(response => {
          this.stockJournalData = response.data;
        });
    },

    loadingByJournal: function(id) {
      
      stockjournalentryService.getListByJournal(id)
        .then(response => {       
          this.stockJournalEntryData = response.data;
        });
    },

    formatDate : function (date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },

    formatCurrency(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;

    },
    print() {
      window.print();
    }
  },
};

</script>

<template>
  <Layout>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('sale.schedule.view')" />
      <div id="print-area">
        <center>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="21%"><p>&nbsp;</p></td>
                <td width="20%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 015 55 40 77 | 078 55 40 77 Email: account@h-residence.net</p>
                </td>
                <td>

                </td>
                <td class="center">
                    <p class="khm h4"><u>{{stockJournalData && stockJournalData.name}}</u></p>
                    <p class="khb h6"><b>លេខ: {{stockJournalData && stockJournalData.code}}</b></p>
                    <!-- <p class="khb h6"><b>កាលបរិច្ឋេទៈ/ Date: 01-May-2021</b></p>   -->
                </td>
              </tr>
              
            </table>
            <br>
            <br>
            <table class="content-general p-3 khs h4 project-sumary-table" width="100%">
              
                <tr class="thead">
                  <th class="p-2">លេខ</th>
                  <th class="p-2">ថ្ងៃ.ខែ.ឆ្នាំ</th>
                  <th class="p-2">ឈ្មោះម្ចាស់ភាគហ៊ុន</th>
                  <th class="p-2">ភាគហ៊ុន</th>
                  <th class="p-2">ចំនួនទឺកប្រាក់</th>
                  <th class="p-2">កំណត់ចំណាំ</th>
                  <!-- <th v-for="head in data.header" :key="head.id">{{head.name}}</th> --> 
                </tr>
              <tbody>
                <tr v-for="(item, index) in stockJournalEntryData" :key="index">
                  <td class="p-2" style="width: 50px;">{{(index+1)}}</td>
                  <td class="p-2" style="width: 150px;">{{stockJournalData && formatDate(stockJournalData.invest_date)}}</td>
                  <td class="p-2" style="width: 250px; text-align: left;">{{item && item.name}}</td>
                  <td class="p-2" style="width: 100px;">{{item.share}}%</td>
                  <td class="p-2" style="width: 150px;">{{formatCurrency(item.invest_share)}}</td>
                  <td class="p-2" >{{item.notation}}</td>
                </tr>
                <tr>
                  <td class="p-2" colspan="3">សរុប</td>
                  <td class="p-2" >{{stockJournalEntryData.reduce((acc, item) => acc + item.share, 0)}}%</td>
                  <td class="p-2" >{{formatCurrency(stockJournalEntryData.reduce((acc, item) => acc + item.invest_share, 0))}}</td>
                  <td class="p-2" ></td>
                </tr>
              </tbody>
            </table>
            <br>
            <table width="90%" class="content-general h4">
              <tr>
                <td class="text-center" v-for="(item, index) in stockJournalEntryData" :key="index">
                  <p class="khs h5 text-center">បានពិនិត្យ និងឯកភាព</p>
                  <p class="khs h6 text-center">{{item.position}}</p>
                  <br/><br/><br/><br/><br/><br/>
                  {{item && item.name}}
                  <br/><br/>
                  <p class="khs h8">ថ្ងៃទី ........................................................</p>
                </td>
                <td class="text-center">
                  <p class="khs h5 text-center">ត្រួតពិនិត្យដោយ</p>
                  <p class="khs h6 text-center">ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <br/><br/><br/><br/><br/><br/>
                  
                  <br/><br/>
                  <p class="khs h8">ថ្ងៃទី ........................................................</p>
                </td>
                <td class="text-center">
                  <p class="khs h5 text-center">អ្នកចុះបញ្ចី</p>
                  <p class="khs h6 text-center">ផ្នែកគណនេយ្យ</p>
                  <br/><br/><br/><br/><br/><br/>
                  លី រដ្ឋា
                  <br/><br/>
                  <p class="khs h8">ថ្ងៃទី ........................................................</p>
                </td>
              </tr>
            </table>
          </div>
        </center>
      </div>
    <!-- end row -->
  </Layout>
</template>